



























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Engine, { Event, Planet, Player } from "@gaia-project/engine";
import { ButtonData } from "../data";
import { specialActionButton } from "../logic/buttons/actions";
import { enabledButtonWarnings } from "../data/warnings";

@Component
export default class SpecialAction extends Vue {
  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: false })
  highlighted: boolean;

  @Prop({ default: false })
  board: boolean;

  @Prop({ default: false })
  recent: boolean;

  @Prop()
  action: string[];

  @Prop()
  planet: Planet;

  onClick() {
    if (!this._highlighted) {
      this.$emit("click");
      return;
    }
    this.$store.dispatch("specialActionClick", this.button);
  }

  get income() {
    return this.action.join(",");
  }

  techEvent(act: string): Event {
    return new Event((this.board ? '' : '>') + act);
  }

  get gameData(): Engine {
    return this.$store.state.data;
  }

  get button(): ButtonData | null {
    if (this.board) {
      return null;
    }
    const player = this.$store.state.player?.index ?? this.gameData.currentPlayer;
    return specialActionButton(this.income, this.gameData.player(player));
  }

  get warning(): boolean {
    const b = this.button;
    return b ? enabledButtonWarnings(b, this.$store.state.preferences).length > 0 : false;
  }

  /** When the action content is highlighted - not the parent component */
  get _highlighted() {
    const actions = this.$store.state.context.highlighted.specialActions;
    return actions.has(this.income) || actions.has(this.income.replace(/>/g, ""));
  }

  get isHighlighted() {
    return this.highlighted || this._highlighted;
  }
}
